import { FiCheck, FiX } from 'react-icons/fi'

import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import { Button } from '~/components/Buttons'

import * as S from '../../styles'
import { getErrorTitle } from '../../utils'

type StructuredErrorProps = {
  code?: string
  message?: string
  missing_headers?: string[]
  found_headers?: string[]
  onBack: () => void
}

export const StructuredError = ({
  code,
  message,
  missing_headers,
  found_headers,
  onBack
}: StructuredErrorProps) => {
  const isValidationErrorsCode = code === 'VALIDATION_ERRORS'
  const shouldUseMessage = isValidationErrorsCode && message

  return (
    <S.ErrorContainer>
      <S.ErrorListContainer>
        {shouldUseMessage ? (
          <S.AlertSection>
            <Alert variant="critical">
              <div>
                <S.ErrorMessage>{message}</S.ErrorMessage>
              </div>
            </Alert>
          </S.AlertSection>
        ) : (
          code && (
            <S.AlertSection>
              <Alert variant="critical">
                <div>
                  <S.ErrorMessage>{getErrorTitle(code)}</S.ErrorMessage>
                </div>
              </Alert>
            </S.AlertSection>
          )
        )}

        {missing_headers && missing_headers.length > 0 && (
          <S.Section>
            <S.SectionTitle>
              <S.SectionIcon color="danger">
                <FiX />
              </S.SectionIcon>
              {t('rm:externalCampaignMetrics.form.error.missingHeaders')}
            </S.SectionTitle>
            <S.TagList>
              {missing_headers.map((header, index) => (
                <S.Tag key={index} variant="danger">
                  {header}
                </S.Tag>
              ))}
            </S.TagList>
          </S.Section>
        )}

        {found_headers && found_headers.length > 0 && (
          <S.Section>
            <S.SectionTitle>
              <S.SectionIcon color="success">
                <FiCheck />
              </S.SectionIcon>
              {t('rm:externalCampaignMetrics.form.error.foundHeaders')}
            </S.SectionTitle>
            <S.TagList>
              {found_headers.map((header, index) => (
                <S.Tag key={index} variant="success">
                  {header}
                </S.Tag>
              ))}
            </S.TagList>
          </S.Section>
        )}
      </S.ErrorListContainer>

      <S.ButtonContainer>
        <Button
          text={t('rm:externalCampaignMetrics.form.error.back')}
          template="primary"
          onClick={onBack}
        />
      </S.ButtonContainer>
    </S.ErrorContainer>
  )
}
